<div class="container-custom">
  <div class="table-header">
    <h2 class="title">Pedimentos</h2>
    <button (click)="mostrarAbandonoForm()">Registro Pedimento</button>
  </div>
  <div class="totales mt-4">
    <nav class="movimiento">
      <li (click)="typesCustom(1)" [ngClass]="{active: togleActives === 1 }">
        <a>Todos</a>
      </li>
      <li (click)="typesCustom(2)" [ngClass]="{active: togleActives === 2 }">
        <a>Activos</a>
      </li>
      <li (click)="typesCustom(3)" [ngClass]="{active: togleActives === 3 }">
        <a>No activos</a>
      </li>
    </nav>
  </div>
  <app-table
    [table_config]="table_config"
    [array]="pedimentos"
    [loader]="loader"
    (onDescargarPedimento)="downloadPedimento($event)"
    (onEliminarAbandono)="confirm($event)"
    (onActualizarAbandono)="mostrarActualizar($event)"
  ></app-table>
</div>
<div class="overlay-detalle" *ngIf="showAbandonoForm">
  <div class="detalle-salida">
    <div class="table-header">
      <h2 class="title">
        <span (click)="toggleOverlay()">
          <app-arrow-back></app-arrow-back>
        </span>
        {{ titulo }}
      </h2>
    </div>
    <form
      class="container-grid"
      [ngStyle]="containerStyles"
      autocomplete="on"
      [formGroup]="pedimentoForm"
      (ngSubmit)="confirmPedimentoForm()"
    >
      <div>
        <label for="no-patente-aduanal" class="form-label"
          >No. Patente Aduanal*</label
        >
        <input
          type="number"
          id="no-patente-aduanal"
          class="form-control"
          formControlName="no_customs_patent"
        />
      </div>
      <div>
        <label for="pedimento" class="form-label">Pedimento*</label>
        <input
          type="text"
          id="pedimento"
          class="form-control"
          formControlName="number_customs_entry"
          appBlockLetters
          minlength="4"
          maxlength="15"
          (input)="noPatentValue()"
        />
        <div>
          <span class="form-text text-danger" *ngIf="pedimentoForm.get('number_customs_entry')?.hasError('required') && pedimentoForm.get('number_customs_entry')?.touched">
            Ingrese el pedimento
          </span>
        </div>
        <div>
          <span class="form-text text-danger" *ngIf="pedimentoForm.get('number_customs_entry')?.hasError('minlength') && pedimentoForm.get('number_customs_entry')?.touched">
            Ingrese el pedimento con al menos 4 digitos
          </span>
        </div>
        <div>
          <span class="form-text text-danger" *ngIf="pedimentoForm.get('number_customs_entry')?.hasError('pattern') && pedimentoForm.get('number_customs_entry')?.touched">
            Solo numeros enteros
          </span>
        </div>
      </div>
      <div>
        <label for="toneladas-liberadas" class="form-label"
          >Toneladas de pedimento*</label
        >
        <input
          type="text"
          id="toneladas-liberadas"
          class="form-control"
          formControlName="custom_entry_tons_released"
          maxlength="15"
          appBlockLetters
        />
        <div>
          <span class="form-text text-danger" *ngIf="pedimentoForm.get('custom_entry_tons_released')?.hasError('required') && pedimentoForm.get('custom_entry_tons_released')?.touched">
            Ingrese las toneladas liberadas
          </span>
        </div>
        <div>
          <span class="form-text text-danger" *ngIf="pedimentoForm.get('custom_entry_tons_released')?.hasError('pattern') && pedimentoForm.get('custom_entry_tons_released')?.touched">
            Maximo once enteros y tres decimales
          </span>
        </div>
      </div>
      <div>
        <label for="toneladas-entrada-liberadas" class="form-label"
        >Toneladas de salida*</label
        >
        <input
          type="text"
          id="toneladas-entrada-liberadas"
          class="form-control"
          formControlName="tons_released"
          maxlength="15"
          appBlockLetters
        />
        <span class="form-text text-danger" *ngIf="campoEsValido('tons_released')">
          Ingrese toneladas validas
        </span>
      </div>
      <div>
        <label for="super-sacos" class="form-label">Piezas/Super sacos</label>
        <input
          type="text"
          id="super-sacos"
          class="form-control"
          formControlName="big_bags"
          maxlength="11"
          appBlockLetters
        />
        <span class="form-text text-danger" *ngIf="pedimentoForm.get('big_bags')?.hasError('pattern') && pedimentoForm.get('big_bags')?.touched">
          Solo numeros enteros
        </span>
      </div>
      <div>
        <label for="fecha" class="form-label">Fecha*</label>
        <input
          type="date"
          id="fecha"
          class="form-control"
          formControlName="customs_entry_payment_date"
        />
        <span class="form-text text-danger" *ngIf="campoEsValido('customs_entry_payment_date')">
          Ingrese la fecha
        </span>
      </div>
      <div>
        <label for="valorComercial_pedimento" class="form-label">Valor comercial*</label>
        <input
          type="text"
          id="valorComercial_pedimento"
          class="form-control"
          formControlName="commercial_value"
          appBlockLetters
        />
        <span
          class="form-text text-danger"
          *ngIf="campoEsValido('commercial_value')"
        >
          Ingresa el valor comercial valido
        </span>
      </div>
      <div>
        <label for="agencia-aduanal" class="form-label">Agente aduanal*</label>
        <input
          type="text"
          id="agencia-aduanal"
          class="form-control"
          formControlName="customs_agency"
          maxlength="100"
        />
        <span
          class="form-text text-danger"
          *ngIf="missingAgent && pedimentoForm.get('number_customs_entry')?.touched"
        >
          No existe agente aduanal para este no. de patente
        </span>
      </div>
      <div>
        <label for="clave-pedimento" class="form-label">Clave pedimento*</label>
        <select
          id="clave-pedimento"
          class="form-control"
          (change)="togleCustomKey()"
          formControlName="customs_entry_key"
        >
          <option value="">-- Seleccionar --</option>
          <option *ngFor="let item of keyList" [value]="item.id">
            {{ item.description }}
          </option>
        </select>
        <span
          class="form-text text-danger"
          *ngIf="campoEsValido('customs_entry_key')"
        >
          Seleccione la clave del pedimento
        </span>
      </div>
      <div *ngIf="pedimentoForm.get('customs_entry_key')?.value == 4 && rectifiedCustom">
        <label for="pedimentoRectificado" class="form-label">Pedimento rectificado*</label>
        <input
          type="text"
          id="pedimentoRectificado"
          class="form-control"
          [value]="rectifiedCustom"
          disabled
        />
      </div>
      <div *ngIf="pedimentoForm.get('customs_entry_key')?.value == 4 && this.titulo.includes('Crear')">
        <p class="form-label w-100">
          ¿Se tiene el pedimento a rectificar?
        </p>
        <label for="r1True" class="form-check-label" style="font-size: 1.6rem;">Si</label>
        <input
          type="radio"
          class="form-check-input ms-3"
          id="r1True"
          [value]="true"
          formControlName="hasCustom"
        />
        <label for="r1False" class="form-check-label ms-3" style="font-size: 1.6rem;">No</label>
        <input
          type="radio"
          class="form-check-input ms-3"
          id="r1False"
          [value]="false"
          formControlName="hasCustom"
        />
      </div>
      <div *ngIf="showCurrendId">
        <label for="activeCustom" *ngIf="!activeCustomLoader" class="form-label">Pedimentos activos{{ rectifiedCustom ? '' : '*'}}</label>
        <p *ngIf="activeCustomLoader" class="form-label">Pedimentos activos*</p>
        <select
          id="activeCustom"
          class="form-control"
          formControlName="current_id"
          *ngIf="!activeCustomLoader"
        >
          <option value="">-- Seleccionar --</option>
          <option *ngFor="let item of activeCustomList" [value]="item.id">
            {{ item.number_customs_entry }}
          </option>
        </select>
        <div class="loader-cotainer" *ngIf="activeCustomLoader">
          <app-loader2></app-loader2>
        </div>
        <span
          class="form-text text-danger"
          *ngIf="campoEsValido('current_id') && !activeCustomLoader"
        >
          Seleccione la clave del pedimento
        </span>
      </div>
      <div *ngIf="pedimentoForm.get('customs_entry_key')?.value == 4">
        <label for="request_type_id" class="form-label">Tipo de pedimento*</label>
        <select
          id="request_type_id"
          class="form-control"
          formControlName="request_type_id"
        >
          <option value="">-- Seleccionar --</option>
          <option *ngFor="let item of requestType" [value]="item.id">
            {{ item.description }}
          </option>
        </select>
        <span class="form-text text-danger" *ngIf="campoEsValido('request_type_id')">
          Seleccione el tipo de pedimento
        </span>
      </div>
      <div>
        <label for="estatusModulacion" class="form-label">Estatus de modulación*</label>
        <select
          id="estatusModulacion"
          class="form-control"
          formControlName="modulation_status"
        >
          <option value="">-- Seleccionar --</option>
          <option *ngFor="let item of modulationStatus" [value]="item.id">
            {{ item.description }}
          </option>
        </select>
        <span class="form-text text-danger" *ngIf="campoEsValido('modulation_status')">
          Seleccione el estatus de modulación
        </span>
      </div>
      <div>
        <label for="oficio-pedimento" class="form-label"
          >Oficio de pedimento*</label
        >
        <input
          type="file"
          id="oficio-pedimento"
          accept=".pdf"
          class="form-control"
          (change)="fileInput($event, 'name_customs_entry_document')"
        />
        <div>
          <span class="form-text text-danger" *ngIf="pedimentoForm.get('file')?.hasError('required') && pedimentoForm.get('file')?.touched">
            {{ errorMessage }}
          </span>
        </div>
      </div>
      <div></div>
      <div><a *ngIf="pedimentoFileUrl" [href]="pedimentoFileUrl" target="_blank" class="form-control fileUrl">Descargar Archivo</a></div>
      <div class="grid-all container-button">
        <button type="button" class="btn-lote" (click)="toggleOverlay()">
          Cancelar
        </button>
        <button type="submit" class="btn-lote ms-5">Guardar</button>
      </div>
    </form>
  </div>
</div>
<app-overlay
  *ngIf="datosIncompletos"
  icono="bi bi-exclamation-circle-fill"
  [mensaje]="mensajeError"
></app-overlay>
<app-overlay
  *ngIf="confirmacion"
  [mensaje]="mensaje"
  [buttons]="true"
  (onDeleteLote)="guardar($event)"
></app-overlay>
<app-overlay
  *ngIf="informacionGuardada"
  icono="bi bi-check2"
  [mensaje]="mensajeExito"
></app-overlay>
<app-overlay
  *ngIf="loteEliminar"
  [buttons]="true"
  mensaje="¿Está seguro de eliminar el registro de este pedimento?"
  (onDeleteLote)="deleteLote($event)"
></app-overlay>
<app-overlay
  *ngIf="filerError"
  icono="bi bi-exclamation-circle-fill"
  mensaje="Este registro no tiene asignado un archivo"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
